<script>
  import ClickOut from '../../../../utils/directives/clickout'
  import VueEasyPieChart from 'vue-easy-pie-chart'
  import 'vue-easy-pie-chart/dist/vue-easy-pie-chart.css'

  export default{
    data () {
      return {
        open: false
      }
    },
    computed: {},
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      }
    },
    components: {VueEasyPieChart},
    directives: {ClickOut}
  }
</script>

<template>
  <li class="dropdown pos-stc" :class="{ open: open }"><a href="javascript://" data-toggle="dropdown"
                                                          class="dropdown-toggle"
                                                          v-click-out="hide"
                                                          @click="toggle"> <span>Stats</span>
    <span class="caret"></span> </a>
    <div class="dropdown-menu wrapper w-full bg-white">
      <div class="row">
        <div class="col-sm-4">
          <div class="m-l-xs m-t-xs m-b-xs font-bold">Pages <span class="badge badge-sm bg-success">10</span></div>
          <div class="row">
            <div class="col-xs-6">
              <ul class="list-unstyled l-h-2x">
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Profile</a></li>
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Post</a></li>
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Search</a></li>
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Invoice</a></li>
              </ul>
            </div>
            <div class="col-xs-6">
              <ul class="list-unstyled l-h-2x">
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Price</a></li>
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Lock screen</a>
                </li>
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Sign in</a></li>
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Sign up</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-sm-4 b-l b-light">
          <div class="m-l-xs m-t-xs m-b-xs font-bold">UI Kits <span class="label label-sm bg-primary">12</span></div>
          <div class="row">
            <div class="col-xs-6">
              <ul class="list-unstyled l-h-2x">
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Buttons</a></li>
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Icons <span
                        class="badge badge-sm bg-warning">1000+</span></a></li>
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Grid</a></li>
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Widgets</a></li>
              </ul>
            </div>
            <div class="col-xs-6">
              <ul class="list-unstyled l-h-2x">
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Bootstap</a></li>
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Sortable</a></li>
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Portlet</a></li>
                <li><a href="javascript://"><i class="fa fa-fw fa-angle-right text-muted m-r-xs"></i>Timeline</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-sm-4 b-l b-light">
          <div class="m-l-xs m-t-xs m-b-sm font-bold">Analysis</div>
          <div class="text-center">
            <div class="inline">
              <vue-easy-pie-chart
                          :percent="65"
                          :line-width="50"
                          :track-color="'#e8eff0'"
                          :bar-color="'#23b7e5'"
                          :scale-color="''"
                          :size="100"
                          :rotate="90"
                          :line-cap="'butt'"
                          :animate="2000"
                          :font-size="'0'">
              </vue-easy-pie-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<style scoped>
  .vue-easy-pie-chart .inner-text {
    color: #000 !important;
    text-shadow: #FFFFFF 2px;
  }
</style>



// WEBPACK FOOTER //
// DDMega.vue?54aa5055